import React, { Fragment } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';
import Select, { components } from 'react-select';
import { toast } from 'react-toastify';

import { copyToClipboard } from './clipboard';

const vkpBgStyles = {
    backgroundImage: 'url(https://vkplay.ru/hotbox/content_files/media/1652863578_vkplay.svg)',
    backgroundSize: '3.5%',
    backgroundPosition: '12px 50%',
    backgroundRepeat: 'no-repeat',
    paddingLeft: '45px',
};

const p1BgStyles = {
    ...vkpBgStyles,
    backgroundImage: 'url(https://vkplay.ru/hotbox/content_files/media/1613722185_favicon-p1.svg)',
};

const cybersportBgStyles = {
    ...vkpBgStyles,
    backgroundImage: 'url(https://vkplay.ru/hotbox/content_files/media/1658309450_cybersport.svg)',
};

const MultiValueContainer = (props) => (
    <components.MultiValueContainer {...props}>
        <Button
            variant="outline-dark"
            size="sm"
            onClick={() => {
                copyToClipboard(props.data.label);
                toast.success('Текст для вставки скопирован в буфер обмена!');
            }}
        >
            <FontAwesomeIcon icon="copy" />
        </Button>
        <components.MultiValueLabel {...props} />

    </components.MultiValueContainer>
);

export default class SelectSearch extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {};
        this.onChange = this.onChange.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.controller = new AbortController();
    }

    fetchData(uri, search_value) {
        if (this.controller) {
            this.controller.abort();
        }

        this.controller = new AbortController();

        if (this.props.staticData) {
            this.setState({
                results: this.props.staticData,
                isUriChanged: false,
                isLoading: false,
            });

            return;
        }

        this.setState({
            isLoading: true,
        });

        let uri_concat_sym = '?';

        if (this.props.req_uri.indexOf('?') > -1) {
            uri_concat_sym = '&';
        }

        let search_query = `${uri_concat_sym}search=${search_value}`;

        if (this.props.req_uri.indexOf('search=') > -1) {
            search_query = '';
        }

        fetch(this.props.req_uri + search_query, { signal: this.controller.signal })
            .then((response) => response.json())
            .then((data) => this.setState({
                ...data,
                isUriChanged: false,
                isLoading: false,
            }));
    }

    componentDidMount() {
        let qs = '';

        if (this.props.searchValue) {
            qs = this.props.searchValue;
        }

        if (this.props.id === 'channels') {
            qs = '&limit=50';
        }

        this.fetchData(this.props.req_uri, qs);
    }

    componentDidUpdate(prevProps) {
        const { req_uri } = this.props;

        if (prevProps.req_uri !== req_uri) {
            this.setState({
                isUriChanged: true,
            });
        }
    }

    handleMenuOpen = () => {
        const { req_uri } = this.props;
        const { isUriChanged } = this.state;

        if (isUriChanged) {
            this.fetchData(req_uri, '');
        }
    };

    onChange(value) {
        if (this.props.isMulti) {
            this.props.onChange({
                target: {
                    id: this.props.id,
                    type: this.props.id,
                    value: value.map((option) => ({
                        id: option.value,
                        name: option.label,
                        title: option.label,
                        slug: option.slug,
                    })),
                },
                currentTarget: {
                    id: this.props.id,
                    type: this.props.id,
                    value: value.map((option) => ({
                        id: option.value,
                        name: option.label,
                        title: option.label,
                        slug: option.slug,
                    })),
                },
            });
        } else {
            this.props.onChange({
                target: {
                    id: this.props.id,
                    type: this.props.id,
                    value,
                },
                currentTarget: {
                    id: this.props.id,
                    type: this.props.id,
                    value,
                },
            });
        }

        if (value.className) {
            // handle newly created.
        } else {
            this.setState({ storageTypeId: value.id });
        }
    }

    onInputChange(value) {
        if (this.props.keepSearchOnClose && !value) {
            return;
        }

        this.fetchData(this.props.req_uri, value);
    }

    reformatOptions() {
        if (this.props.isAuthors) {
            if (this.state.results) {
                return this.state.results.map((option) => ({ value: option.email, label: `${option.nick} (${option.email})` }));
            }

            return [];
        }

        if (this.state.results) {
            const results = [];

            for (let i = 0; i < this.state.results.length; i++) {
                if (this.props.publishedOnly && !this.state.results[i].is_published) {
                    continue;
                }

                const option = this.state.results[i];

                if (this.props.excludes.indexOf(option.id) < 0) {
                    let ext_info = '';

                    if (option.is_ugc) {
                        ext_info += '[UGC]';
                    }

                    if (option.author_info) {
                        ext_info += `[${option.author_info.email}]`;
                    }

                    const isCyber = option.channels?.includes('cybersport');
                    const isVKP = !isCyber && option.project === 'media.vkplay.ru';
                    const { isGof } = option;

                    results.push({
                        value: option.id,
                        label: `${option.name || option.title} ${ext_info}`,
                        slug: option.slug || '',
                        name: (option.name || option.title),
                        title: (option.name || option.title),
                        date_published: option.date_published,
                        published_at: option.published_at,
                        isVKP,
                        isCyber,
                        isGof,
                    });
                }
            }

            return results;
        }

        return [];
    }

    getDefaultValues() {
        if (!this.props.default_values) {
            return null;
        }

        if (!this.props.default_values[0]) {
            return null;
        }

        const results = [];

        if (this.props.isAuthors) {
            if (this.props.default_values) {
                for (let i = 0; i < this.props.default_values.length; i++) {
                    const option = this.props.default_values[i];

                    if (!option.email) {
                        continue;
                    }

                    results.push({ value: option.email, label: `${option.nick} (${option.email})`, slug: option.slug || '' });
                }
            }

            return results;
        }

        if (this.props.default_values) {
            for (let i = 0; i < this.props.default_values.length; i++) {
                const option = this.props.default_values[i];

                if (option.id) {
                    results.push({ value: option.id, label: (option.name || option.title), slug: option.slug || '' });
                } else if (option.value) {
                    results.push(option);
                }
            }
        }

        return results;
    }

    render() {
        const { isLoading } = this.state;

        return (
            <>
                {isLoading && <span className="select_loading" />}
                {/* TODO: необходимо отключить локальный поиск */}
                <Select
                    isMulti={this.props.isMulti}
                    value={this.props.isSingle ? this.props.default_value : this.getDefaultValues()}
                    name={this.props.name}
                    className={this.props.name}
                    classNamePrefix="select"
                    options={this.reformatOptions()}
                    formatOptionLabel={this.formatOptionLabel}
                    onChange={this.onChange}
                    onMenuOpen={this.handleMenuOpen}
                    onInputChange={this.onInputChange}
                    pageSize={20}
                    components={{ MultiValueContainer }}
                    styles={{
                        control: (provided) => ({
                            ...provided, ...this.props.style,
                        }),
                        option: (styles, {
                            data,
                        }) => ({
                            ...styles,
                            ...(data.isVKP ? vkpBgStyles : {}),
                            ...(data.isCyber ? cybersportBgStyles : {}),
                            ...(!data.isCyber && !data.isVKP && !data.isGof ? p1BgStyles : {}),
                        }),
                    }}
                />
            </>
        );
    }
}
